module.exports = __webpack_public_path__ + "gm992021/img/qiji-4.png?f77d0fae";